import { render, staticRenderFns } from "./AttachmentsList.vue?vue&type=template&id=7772d9d7&scoped=true"
import script from "./AttachmentsList.vue?vue&type=script&lang=js"
export * from "./AttachmentsList.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsList.vue?vue&type=style&index=0&id=7772d9d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7772d9d7",
  null
  
)

export default component.exports